import { getStringToCharacters, stringCharactersAddActive, stringCharactersRemoveActive } from './inc/string-to-characters';
import elmntIO from './inc/elmnt-io';

export function setupBaseTextCharAnimation() {
    const $textElmnts = document.querySelectorAll('[data-char-animation]');
    const slideAnimations = ['slide-up', 'slide-down', 'slide-right'];
    var previousAnimation = null;

    $textElmnts?.forEach($textElmnt => {
        const htmlSplitStr = getStringToCharacters($textElmnt.innerHTML, {charInner: true});
        $textElmnt.innerHTML = htmlSplitStr;

        // add data-char-animation value
        if ( !$textElmnt.hasAttribute('data-char-animation') ) {
            $textElmnt.setAttribute('data-char-animation', 'slide-up');
            previousAnimation = 'slide-up';
        } else if ( 'slide' == $textElmnt.dataset.charAnimation) {
            $textElmnt.setAttribute('data-char-animation', 'slide-up');
            previousAnimation = 'slide-up';
        } else if ( 'slide-rand' == $textElmnt.dataset.charAnimation) {
            // set random animation that does not match previous animation
            let availableAnimations = slideAnimations.filter(animation => animation !== previousAnimation);
            let randomAnimation = availableAnimations[Math.floor(Math.random() * availableAnimations.length)];
            $textElmnt.setAttribute('data-char-animation', randomAnimation);
            previousAnimation = randomAnimation;
        }


        // elmntIo
        $textElmnt.classList.add('ignore-io');

        if ( !$textElmnt.hasAttribute('data-io') ) {
            $textElmnt.setAttribute('data-io', '');
        }

        if ( !$textElmnt.hasAttribute('data-io-threshold') ) {
            $textElmnt.setAttribute('data-io-threshold', '0');
        }

        if ( !$textElmnt.hasAttribute('data-io-margin') ) {
            $textElmnt.setAttribute('data-io-margin', '-1% 0% -10% 0%');
        }

        elmntIO($textElmnt, handleIoEnter, handleIoExit);
    });

    function handleIoEnter(entry) {
        stringCharactersAddActive(entry.target, {duration: 800});
    }

    function handleIoExit(entry) {
        stringCharactersRemoveActive(entry.target, {interval: 1});
    }
}

